import { inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CreditSetupResponse, CreditSetupStatus } from '@brightside-web/desktop/data-access/shared';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';

import { from, Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { BsCacheService } from '@brightside-web/desktop/data-access/core-services';

@Injectable({
  providedIn: 'root',
})
export class InVerifyGuard implements CanActivate {

  bsCacheService: BsCacheService = inject(BsCacheService);

  constructor(private router: Router, private creditSetupService: CreditSetupService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.creditSetupService.getSetupStatus().pipe(
      switchMap((resp: CreditSetupResponse) => {
        return from(this.bsCacheService.getItem('ONBOARDING_FLOW_ACTIVE')).pipe(
          map(onboarding => {
              if ([CreditSetupStatus.VERIFY_SMFA, CreditSetupStatus.VERIFIED, CreditSetupStatus.VERIFY_SMFA_TIMEOUT].includes(resp.status)) {
                return true;
              }

              //Check where to go if we are not in verify
              if (resp.status === CreditSetupStatus.NOT_STARTED) {
                this.router.navigate(['credit-setup', 'consents']);
                return false;
              }

              //Check if we should actually be in dashboard
              if (resp.status === CreditSetupStatus.ENROLLED) {
                if (onboarding) {
                  this.creditSetupService.creditSucceeded.set(true);
                  return this.router.createUrlTree(['onboarding']);
                } else {
                  this.creditSetupService.getSetupStatus();
                  return this.router.createUrlTree(['credit', 'dashboard']);
                }
              }

              //Check if terms are accepted
              if (resp.status === CreditSetupStatus.TERMS_ACCEPTED) {
                this.router.navigate(['credit-setup', 'creation-waiting']);
                return false;
              }

              this.router.navigate(['credit-setup', 'creation'], { queryParams: { status: resp.status } });
              return false;

          }))

      })
    );
  }
}
